[
  {
    "id": 1,
    "text": "Census Bureau, Population and Housing Unit Estimates.",
    "url": "https://www.census.gov/programs-surveys/popest.html"
  },
  {
    "id": 2,
    "text": "Census Bureau, American Community Survey (ACS).",
    "url": "https://www.census.gov/programs-surveys/acs.html"
  },
  {
    "id": 3,
    "text": "Centers for Disease Control and Prevention, PLACES: County Data (GIS Friendly Format).",
    "url": "https://data.cdc.gov/500-Cities-Places/PLACES-County-Data-GIS-Friendly-Format-2024-releas/i46a-9kgh/about_data"
  },
  {
    "id": 4,
    "text": "Centers for Disease Control and Prevention, Division of Healthcare Quality Promotion, National Healthcare Safety Network, Weekly United States Hospital Respiratory Data (HRD) Metrics by Jurisdiction, National Healthcare Safety Network (NHSN).",
    "url": "https://data.cdc.gov/Public-Health-Surveillance/Weekly-Hospital-Respiratory-Data-HRD-Metrics-by-Ju/ua7e-t2fy/about_data"
  },
  {
    "id": 5,
    "text": "Centers for Disease Control and Prevention, BEAM (Bacteria, Enterics, Amoeba, and Mycotics) Dashboard. Atlanta, Georgia: U.S. Department of Health and Human Services.",
    "url": "https://data.cdc.gov/Foodborne-Waterborne-and-Related-Diseases/BEAM-Dashboard-Report-Data/jbhn-e8xn/about_data"
  },
  {
    "id": 6,
    "text": "Centers for Disease Control and Prevention, NNDSS Weekly Data.",
    "url": "https://data.cdc.gov/NNDSS/NNDSS-Weekly-Data/x9gk-5huc/about_data"
  },
  {
    "id": 7,
    "text": "Turner L. Point-of-Care Testing in the Urgent Care Setting. Sekisuidiagnostics.com. Published May 15, 2019.",
    "url": "https://blog.sekisuidiagnostics.com/dxdialogue/point-of-care-testing/2019/05/15/point-of-care-testing-in-the-urgent-care-setting"
  },
  {
    "id": 8,
    "text": "Fistera D, Kikull K, Risse J, Herrmann A, Brachmann M, Kill C. Point-of-care PCR testing of SARS-CoV-2 in the emergency department: Influence on workflow and efficiency. PLOS ONE. 2023;18(8):e0288906",
    "url": "https://doi.org/10.1371/journal.pone.0288906"
  },
  {
    "id": 9,
    "text": "Clark TW, Lindsley K, Wigmosta TB, et al. Rapid multiplex PCR for respiratory viruses reduces time to result and improves clinical care: Results of a systematic review and meta-analysis. Journal of Infection. 2023;86(5):462-475.",
    "url": "https://doi.org/10.1016/j.jinf.2023.03.005"
  },
  {
    "id": 10,
    "text": "Rappo U, Schuetz AN, Jenkins SG et al. Impact of early detection of respiratory viruses by multiplex PCR assay on clinical outcomes in adult patients. J Clin Microbiol. 2016; 54: 2096-103.",
    "url": "https://doi.org/doi/10.1128/jcm.00549-16"
  },
  {
    "id": 11,
    "text": "Peri AM, Ling W, Furuya-Kanamori L, Harris PNA, Paterson DL, et al. Performance of BioFire Blood Culture Identification 2 Panel (BCID2) for the detection of bloodstream pathogens and their associated resistance markers: a systematic review and meta-analysis of diagnostic test accuracy studies. BMC Infect Dis. 2022;22(1):794. doi:10.1186/s12879-022-07772-x",
    "url": "https://bmcinfectdis.biomedcentral.com/articles/10.1186/s12879-022-07772-x"
  },
  {
    "id": 12,
    "text": "Axelrad, J, et al. Impact of gastrointestinal panel implementation on health care utilization and outcomes. J Clin Mirobiol. 2019;57(3):e01775-18. doi: 10.1128/JCM.01775-18",
    "url": "https://doi.org/10.1128/jcm.01775-18"
  },
  {
    "id": 13,
    "text": "Bard J, McElvania E. Panels and syndromic testing in clinical microbiology. Clin Lab Med. 2020;40(4):393-420. doi: 10.1016/j.cll.2020.08.001",
    "url": "https://doi.org/10.1016/j.cll.2020.08.001"
  }
]